import { collection, getDocs, query, where } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Subscription from '../../models/Subscription';

async function getSubscriptionByApiKey(
  apiKey: string
): Promise<Subscription | null> {
  try {
    const db = firestore;

    const apiKeyQueryResults = await getDocs(
      query(
        collection(db, FirestoreCollections.subscriptions),
        where('api_key', '==', apiKey)
      )
    );

    const subscriptions: Subscription[] = [];

    apiKeyQueryResults.docs.forEach((doc) => {
      subscriptions.push(Subscription.fromFirestore(doc));
    });

    const firstMatch = subscriptions[0];

    if (!firstMatch) {
      return null;
    }

    return firstMatch;
  } catch (e) {
    console.log('error: ', e);
    throw new GetSubscriptionByApiKeyFailure();
  }
}

export class GetSubscriptionByApiKeyFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getSubscriptionByApiKey;
